<template>
  <router-view v-slot="{ Component }">
    <component :key="$route.path" :is="Component"/>
  </router-view>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style scoped>
</style>
